// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import polyfill from 'babel-polyfill'
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import axios from 'axios'
import request from './common/request.js'
import echarts from 'echarts'
// import BaiduMap from 'vue-baidu-map'  //common.js中另一种方法引入bmap跟echares联动
import * as tools from '@/common/validate'
import * as common from '@/common/common'
import Clipboard from 'clipboard';
import router from './router'
import VueCookies from 'vue-cookies'
// import i18n from './assets/lang/index'
import less from 'less'
import locale from 'element-ui/lib/locale/lang/en'
import Loading from './components/design/Loading'
import VueCropper from 'vue-cropper'
Vue.use(VueCropper);//引入图片裁剪

Vue.component(  //自定义等待框
  'Loading',Loading
)



request.init();
// Vue.use(ElementUI);
// Vue.use(ElementUI, { locale })
Vue.use(polyfill);
Vue.use(VueCropper);//引入图片裁剪
Vue.use(ElementUI, {
  // i18n: (key, val) => i18n.t(key, val)
  // i18n: (key, value) => i18n.vm._t(key, value)
})
Vue.use(VueCookies);
// Vue.use(BaiduMap, {
//   ak: 'K8FGD0d4S4qlo4MsZb5musrUSbG1Ps2G'  //这个地方是官方提供的ak密钥
// })
Vue.use(less)


Vue.prototype.$tools = tools;
Vue.prototype.$common = common;
Vue.prototype.$echarts = echarts
Vue.prototype.$axios = axios;
Vue.prototype.clipboard = Clipboard;//引入复制粘贴
Vue.config.productionTip = false

Vue.POWER = [];

router.beforeEach(function (to, from, next) {
  Vue.POWER = [];
  // console.log(from);
  // if (from.name == 'OrderSubProjects') {
  //   if (confirm('确定离开当前页面吗')) {
  //
  //   } else {
  //     return;
  //   }
  // }
  document.title = to.meta.title;
  let PowerUrlAry = [];


  axios.get('https://passport.hzjly.cn/api/Permission/PermissionList', {
    params: {
      siteguid: '49c92848-ef65-467f-87aa-67e2a43796f9', ispower: true
    }
  })
    .then(function (response) {

      let ary = JSON.parse(response.data).results.rows;
      ary.forEach(item => {
        Vue.POWER.push(item.guid);
      });
      next();
      return;

      axios.get("https://passport.hzjly.cn/api/Permission/PermissionList", {
        params: {
          siteguid: '12193032-2D60-6F2B-1944-B707D8D7E7A9', ispower: ''
        }
      })
        .then(res => {
          let data = JSON.parse(res.data);
          data.results.rows.forEach(item => {
            if (item.url != '') {
              PowerUrlAry.push(item.url);
            }
          })
          PowerUrlAry.push('/404/Page404'); //404页面
          PowerUrlAry.push('/Index');
          PowerUrlAry.push('/SettingPerson');
          next('/Index');


          // if (PowerUrlAry.indexOf(to.path) == -1) {
          //取消权限
          //
          // } else {
          //   next();
          // }
        })

    })


    .catch(err => {

    });


}) //在进入路由之前都会执行一次此方法，全局钩子函数，可以添加拦截功能


/* eslint-disable no-new */
window.vm = new Vue({
  el: '#app',
  router,
  // i18n,//将VueI18n挂载到vue实例上
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js